package com.starparty.app.astro0.js

import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.geometry.SP_Point
import com.starparty.app.geometry.SP_Rectangle
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import kotlin.math.PI

class SP_JSCanvas(val canvas: HTMLCanvasElement): SP_Canvas() {

    val ctx: CanvasRenderingContext2D

    var translateX = 0.0
    var translateY = 0.0

    override val width: Int
        get() {
            return canvas.width
        }

    override val height: Int
        get() {
            return canvas.height
        }

    override val clipBounds: SP_Rectangle
        get() {

            val sp_clip = SP_Rectangle(
                translateX-width,
                height-translateY,
                canvas.width.toDouble(),
                canvas.height.toDouble())

            return sp_clip
        }


    fun adjustPoint(p: SP_Point): SP_Point {

        val newX = p.x - translateX
        val newY = p.y - translateY

        return SP_Point(newX,newY)
    }

    override fun drawColor(c: SP_Colour){
        ctx.fillStyle = "blue"
       // ctx.fillRect(0.0,0.0, canvas.width.toDouble(), canvas.height.toDouble())
    }

    override fun drawText(text:String, x:Double, y:Double, p: SP_Paint)
    {
        ctx.font = p.getFontString()
        ctx.fillStyle = p.getCSSRGBAColorString()
        ctx.fillText(text, x, y)
    }

    override fun drawLine(x1:Double, y1:Double, x2:Double, y2:Double, p: SP_Paint) {

        val b = clipBounds
        var p1 = SP_Point(x1, y1)
        var p2 = SP_Point(x2, y2)

        val intersects = (b.contains(p1.x, p1.y) || b.contains(p2.x, p2.y))

        if (intersects) {
            ctx.strokeStyle = p.getCSSRGBAColorString()
            ctx.lineWidth = p.lineWidth
            ctx.beginPath()
            ctx.moveTo(x1, y1)
            ctx.lineTo(x2, y2)
            ctx.stroke()
        }
    }

    override fun drawRectFilled(rect: SP_Rectangle, p: SP_Paint){
        ctx.fillStyle = p.getCSSRGBAColorString()
        ctx.fillRect(rect.left, rect.top, rect.width, rect.height)
    }

    override fun drawRectUnfilled(rect: SP_Rectangle, p: SP_Paint){
        ctx.strokeStyle = p.getCSSRGBAColorString()
        ctx.strokeRect(rect.left, rect.top, rect.width, rect.height)
    }


    override fun drawCircleFilled(x:Double, y:Double, radius:Double, p: SP_Paint) {
        val left = x - radius
        val top = y + radius
        val d = 2*radius
        val ovalBounds = SP_Rectangle(left, top, d, d)
        //   val clip = g.clipBounds
        //   if (clip.intersects(ovalBounds))
        //   {

        ctx.beginPath()
        ctx.arc(x, y, radius, 0.0, 2*PI, false)
        ctx.fillStyle = p.getCSSRGBAColorString()
        ctx.fill();
        //  }
    }


    override fun drawCircleUnfilled(x:Double, y:Double, radius:Double, p: SP_Paint) {

        ctx.beginPath()
        ctx.arc(x, y, radius, 0.0, 2*PI, false)
        ctx.strokeStyle = p.getCSSRGBAColorString()
        ctx.stroke();
    }

    override fun drawOvalUnfilled(rect:SP_Rectangle, p: SP_Paint){ // l:Double, t:Double, r:Double, b:Double, p: SP_Paint){
        val r1 = rect.width / 2.0
        val r2 = rect.height / 2.0
        val x = rect.left + r1
        val y = rect.top + r2

        ctx.beginPath()
        ctx.ellipse(x, y, r1, r2, 0.0, 0.0, 2*PI, false)
        ctx.strokeStyle = p.getCSSRGBAColorString()
        ctx.stroke();
    }

    override fun translate(x: Double, y: Double){
        translateX = x
        translateY = y

        ctx.translate(x, y)
    }

    init {
        ctx = canvas.getContext("2d") as CanvasRenderingContext2D
    }

}